import React from 'react'
import Service from './create.service'
import { withRouter } from 'react-router-dom'
import RoleForm from '../components/form/form.component'
import FormHelper from '../../../../utils/FormHelper'
import Checkbox from '../../../../components/inputs/checkbox/checkbox.component'
import { connect } from 'react-redux'

class CreateRole extends React.Component {

    constructor(props) {
        super(props)
        this.service = Service(this)
        this.state = this.service.getDefaultState()
    }

    componentDidMount = () => {
        this.service.loadPermissions()
        this.service.loadLocations()
        this.service.loadSalePoints()
    } 

    onSubmit = (e) => {
        e.preventDefault()
        this.service.isValid() && this.service.createRole()
    }

    onCancel = () => this.props.history.push('/security/roles/all')

    onChangePermission = (permissionId, checked) => this.service.onChangeRolePermission(permissionId)

    render() {
        return (
            <div className="create">
                <div className="header">
                    <h4>Create Role</h4>
                </div>
                <div className="card">
                    <div className={"flag " + this.state.flag.type}>
                        {this.state.flag.text}
                    </div>
                    <RoleForm {...this.state} onChange={FormHelper(this, "role").onChange} onSubmit={this.onSubmit} onCancel={this.onCancel}>
                        <h4>Permissions</h4>
                        <div className="row-permissions">
                            {
                                this.state.permissions.map((permission, key) => <Checkbox key={key} name={permission.id} text={permission.name} checked={this.service.containsRolePermission(permission.id)} onChange={this.onChangePermission} />)
                            }
                        </div>
                    </RoleForm>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(CreateRole))